







































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../util/constants';
import { ServiceRequest, RequestStatus } from '@/types/entity';
import { DateUtils } from '@/util/dateUtils';
import { ObjectFactory } from '@/config/objectFactory';
import ServiceRequestDetails from './ServiceRequestDetails.vue';
import { CommonUtils } from '@/util/commonUtils';
import router from '@/router';
import { DriverProfile } from '@/types/response';
import { ApiRequest, QueryRecordsRequest } from '@/types/request';
@Component({
  props: {
    id: String,
  },
  data() {
    return {
      fullName: '',
    };
  },
  components: {
    ServiceRequestDetails,
  },
  watch: {
    '$route.query.requestType'() {
      const requestPanel = this as RequestPanel;
      requestPanel.init();
    },
    '$route.query.status'() {
      const requestPanel = this as RequestPanel;
      requestPanel.init();
    },
    '$route.path'(to, from: string) {
      if (!this.$route.params.id) {
        const requestPanel = this as RequestPanel;
        requestPanel.init();
      }
    },
  },
})
export default class RequestPanel extends Vue {
  private pendingRequests: ServiceRequest[] = [];
  private completedRequests: ServiceRequest[] = [];
  private confirmedRequests: ServiceRequest[] = [];
  private canceledRequests: ServiceRequest[] = [];
  private selectRequestId: string | undefined = '';
  private requestType: any = '';
  private DateUtils = DateUtils;
  private showRequestPanel = false;
  private showNoRequests = true;
  private loading = true;
  private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
  private fullname: string = '';
  private isCNA = false;
  private isInsuranceExpired = false;
  private isDriverLicenceExpired = false;
  private partnerId: string = '';
  private pendingDriverProfiles: DriverProfile[] = [];
  private partnerProfile = {} as any;
  private isStatusPendingVerification = false;

  public mounted() {
    this.fullname = ObjectFactory.getCacheService().getSessionInfo().fullname;
    const status = ObjectFactory.getCacheService().getSessionInfo().status;
    this.init();
    this.validatePartnerDocuments();
    this.validateDriversDocuments();
    if (status === 'PENDING_VERIFICATION') {
      this.isStatusPendingVerification = true;
    }
  }

  private async init() {
    this.loading = true;
    const requestType = this.$route.query.requestType;
    const status = this.$route.query.status;
    this.selectRequestId = this.$route.params.id;
    this.confirmedRequests = [];
    this.pendingRequests = [];
    this.completedRequests = [];
    this.canceledRequests = [];
    if (this.sessionInfo.scopes.includes('transporter') || this.sessionInfo.scopes.includes('driver') ||
      this.sessionInfo.scopes.includes('dispatcher')) {
      this.requestType = requestType ? requestType : 'transportRequest';
      const partnerService = ObjectFactory.getPartnerService();
      const partner = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
      this.partnerProfile = partner.data;
      if (partner.data && partner.data.transporterProfile) {
        const transporter = partner.data.transporterProfile;
        if (transporter.roles && transporter.roles.includes('CNA')) {
          this.isCNA = true;
          this.requestType = 'homeAssistanceRequest' || 'homeHealthCareRequest';
        }
      }
    } else if (this.sessionInfo.scopes.includes('homeHealthCare')) {
      this.requestType = requestType ? requestType : 'homeHealthCareRequest';
    } else {
      this.requestType = requestType ? requestType : 'interpreterRequest';
    }

    if (status) {
      await this.getRequests(status as any, 25);
      this.checkNoRequest();
    } else {
      if (!this.sessionInfo.scopes.includes('driver')) {
        await this.getRequests('Pending');
      }
      await this.getRequests('Confirmed', 5);
      await this.getRequests('Completed', 5);
      await this.getRequests('Canceled', 5);
      this.checkNoRequest();
    }
    this.loading = false;
  }

  private async getRequests(status: RequestStatus, limit?: number) {
    let partnerId = '';
    if (this.sessionInfo.scopes.includes('dispatcher') && this.partnerProfile.dispatcherProfile) {
      partnerId = this.partnerProfile.dispatcherProfile.transporterId;
    }
    if (this.sessionInfo.scopes.includes('transporter') || this.sessionInfo.scopes.includes('interpreter')) {
      partnerId = this.sessionInfo.id;
    }
    const response = await ObjectFactory.getRequestService().getRequests({
      baseURL: this.$store.state.serverUrl,
      conditions: status === 'Pending' ? [{
        op: 'gt',
        fieldName: 'appointment.timestamp',
        value: DateUtils.getCurrentUTCTimeInMillis() - DateUtils.convertMinutesToMillis(60 * 24),
      },
      {
        fieldName: 'assignment.rejectedInvitees.userId',
        op: 'ne',
        value: partnerId,
      }] : [],
      status,
      service: this.requestType,
      limit,
    });
    switch (status) {
      case 'Pending':
        this.pendingRequests = response.data as any;
        if ((!this.selectRequestId && !CommonUtils.isEmpty(this.pendingRequests))) {
          this.selectRequestId = this.pendingRequests[0].id;
          this.showNoRequests = false;
          this.showRequestDetails(this.selectRequestId);
        }
        break;
      case 'Confirmed':
        this.confirmedRequests = response.data as any;
        if ((!this.selectRequestId && !CommonUtils.isEmpty(this.confirmedRequests))) {
          this.selectRequestId = this.confirmedRequests[0].id;
          this.showNoRequests = false;
          this.showRequestDetails(this.selectRequestId);
        }
        break;
      case 'Completed':
        this.completedRequests = response.data as any;
        if ((!this.selectRequestId && !CommonUtils.isEmpty(this.completedRequests))) {
          this.selectRequestId = this.completedRequests[0].id;
          this.showNoRequests = false;
          this.showRequestDetails(this.selectRequestId);
        }
        break;
      case 'Canceled':
        this.canceledRequests = response.data as any;
        if ((!this.selectRequestId && !CommonUtils.isEmpty(this.canceledRequests))) {
          this.selectRequestId = this.canceledRequests[0].id;
          this.showNoRequests = false;
          this.showRequestDetails(this.selectRequestId);
        }
        break;
    }

  }

  private showRequestDetails(id: string | undefined) {
    if (!this.$route.params.id || id !== this.$route.params.id) {
      this.$router.push({ path: `${MedTransGoConstants.URL_REQUESTS}/${id}`, query: this.$route.query });
    }
  }

  private checkNoRequest() {
    this.showRequestPanel = !CommonUtils.isEmpty(this.pendingRequests)
      || !CommonUtils.isEmpty(this.confirmedRequests) || !CommonUtils.isEmpty(this.completedRequests)
      || !CommonUtils.isEmpty(this.canceledRequests);
    this.showNoRequests = !this.showRequestPanel;
  }

  private async validatePartnerDocuments() {
    const partnerService = ObjectFactory.getPartnerService();
    const response = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
    if (response.success && response.data) {
      const partnerProfile = response.data;
      if (partnerProfile.transporterProfile && partnerProfile.transporterProfile.documents) {
        this.partnerId = partnerProfile.transporterProfile.id;
        const objIndex = partnerProfile.transporterProfile.documents.findIndex(((obj) =>
          obj.name === 'Certificate of Insurance'));
        if (objIndex >= 0) {
          const document = partnerProfile.transporterProfile.documents[objIndex];
          if (document.expirationDate && document.expirationDate <= DateUtils.getCurrentTimeInMillis()) {
            this.isInsuranceExpired = true;
          } else {
            this.isInsuranceExpired = false;
          }
        }
      }
      if (partnerProfile.driverProfile && partnerProfile.driverProfile.documents &&
        partnerProfile.driverProfile.id) {
        this.partnerId = partnerProfile.driverProfile.id;
        const objIndex = partnerProfile.driverProfile.documents.findIndex(((obj) =>
          obj.name === 'Driver License'));
        if (objIndex >= 0) {
          const document = partnerProfile.driverProfile.documents[objIndex];
          if (document.expirationDate && document.expirationDate <= DateUtils.getCurrentTimeInMillis()) {
            this.isDriverLicenceExpired = true;
          } else {
            this.isDriverLicenceExpired = false;
          }
        }
      }
      if (partnerProfile.dispatcherProfile && partnerProfile.dispatcherProfile.transporterId) {
        this.partnerId = partnerProfile.dispatcherProfile.transporterId;
      }
    }
  }

  private updatExpiredDocument() {
    router.push({ path: `/settings/documents/update/${this.partnerId}` });
  }

  private async validateDriversDocuments() {
    const iHttpService = ObjectFactory.getHttpService();
    this.pendingDriverProfiles = [];
    const queryRecordsRequest: QueryRecordsRequest = {};
    const apiRequest: ApiRequest = {
      baseURL: this.$store.state.serverUrl,
      data: queryRecordsRequest,
      url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/list`,
      loaderEvent: {
        show: true,
      },
    };
    const response = await iHttpService.post<DriverProfile[]>(apiRequest);
    if (response.data && response.success) {
      for (const driverProfile of response.data) {
        if (!driverProfile.documents || (driverProfile.documents && driverProfile.documents.length < 1)) {
          this.pendingDriverProfiles.push(driverProfile);
        }
      }
    }
  }
  private updateDriverDocument(driverProfile: DriverProfile) {
    router.push({ path: `/settings/drivers/update/${driverProfile.id}` });
  }
}
